import { render, staticRenderFns } from "./premium-paywall.vue?vue&type=template&id=3086fc40&scoped=true"
import script from "./premium-paywall.vue?vue&type=script&lang=js"
export * from "./premium-paywall.vue?vue&type=script&lang=js"
import style0 from "./premium-paywall.vue?vue&type=style&index=0&id=3086fc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086fc40",
  null
  
)

export default component.exports